var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B9DE8",
    d: "M13.714 3.57L10.282.137C10.194.05 10.075 0 9.95 0H2.47C2.209 0 2 .21 2 .469V15.53c0 .26.21.469.469.469h10.914c.259 0 .468-.21.468-.469V3.901c0-.124-.049-.244-.137-.331zM10.42 1.6l1.832 1.832h-1.832V1.6zM2.937 15.062V.938h6.545V3.9c0 .259.21.469.468.469h2.964v10.692H2.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B9DE8",
    d: "M7.594 11.053c.092.091.212.137.332.137.12 0 .24-.046.331-.137l1.794-1.793c.183-.184.183-.48 0-.663-.183-.184-.48-.184-.663 0l-.994.993V6.126c0-.258-.21-.468-.468-.468-.26 0-.47.21-.47.468V9.59l-.992-.993c-.183-.184-.48-.184-.663 0-.183.183-.183.48 0 .663l1.793 1.793zM10.113 12.128H5.738c-.259 0-.469.21-.469.468 0 .26.21.47.47.47h4.374c.26 0 .469-.21.469-.47 0-.258-.21-.468-.469-.468z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADD6F5",
    d: "M10.419 1.6L12.251 3.432 10.419 3.432z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.015776160cc1bad4992da66047193bb2.svg";
export { ForwardRef as ReactComponent };